import { FileTextOutlined, ShoppingCartOutlined, UserOutlined } from "@ant-design/icons";
import { Drawer, Grid, Layout, Menu } from "antd";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { PATHS } from "../router/paths";
import TopHeader from "./TopHeader";
import { BottomNav } from "../../features/home/components/BottomNav";
import { httpClient } from "../../shared/api/httpClient";

const { Content, Sider } = Layout;
const { useBreakpoint } = Grid;

const menuItems = [
  {
    key: PATHS.PROPOSAL,
    icon: <FileTextOutlined />,
    label: "提案",
  },
  {
    key: PATHS.ORDERS,
    icon: <ShoppingCartOutlined />,
    label: "注文状況",
  },
  {
    key: PATHS.PROFILE,
    icon: <UserOutlined />,
    label: "プロフィール",
  },
];

export const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const location = useLocation();

  const onMenuClick = (key: string) => {
    navigate(key);
    setDrawerVisible(false);
  };

  const onShowSidebar = () => {
    if (screens.md) setCollapsed((current) => !current);
    else setDrawerVisible(true);
  };

  const navigation = (
    <Menu
      theme="light"
      mode="inline"
      selectedKeys={[location.pathname]}
      items={menuItems.map((item) => ({
        ...item,
        onClick: () => onMenuClick(item.key),
      }))}
    />
  );

  // const fetchProducts = async (
  //   page = 1,
  //   pageSize = 100,
  //   search?: string,
  // ): Promise<any> => {
  //   const response = await httpClient.get<any>("/products", {
  //     params: {
  //       page,
  //       page_size: pageSize,
  //       search: search?.trim() || undefined,
  //     },
  //   });
  //   return response.data;
  // };

  // useEffect(() => {
  //   fetchProducts();
  // }, []);

  return (
    <Layout style={{ minHeight: "100vh", overflow: "hidden" }}>
      {screens.md && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          width={240}
          theme="light"
          collapsedWidth={0}
          style={{
            overflow: "hidden",
            position: "absolute",
            height: "100vh",
            zIndex: 1000,
            boxShadow: collapsed ? "none" : "2px 0 8px rgba(0,0,0,0.15)",
          }}
        >
          <div
            style={{
              height: 64,
              display: "flex",
              alignItems: "center",
              padding: "0 24px",
              fontSize: 18,
              fontWeight: "bold",
              whiteSpace: "nowrap",
            }}
          >
            顧客ポータル
          </div>
          {navigation}
        </Sider>
      )}

      <Layout
        style={{
          marginLeft: screens.md && !collapsed ? 240 : 0,
          transition: "margin-left 0.2s",
          height: "100vh",
        }}
      >
        <TopHeader onShowSidebar={onShowSidebar} />
        <Content style={{ flex: 1, overflowY: "auto", padding: screens.md ? 18 : "12px 12px 72px 12px" }}>
          <Outlet />
        </Content>
        {!screens.md ? <BottomNav /> : null}
      </Layout>

      <Drawer
        title="顧客ポータル"
        placement="left"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        styles={{ body: { padding: 0 } }}
      >
        {navigation}
      </Drawer>
    </Layout>
  );
};

export default MainLayout;


